export default {
    // market
    tabNews: 'समाचार',
    tabJobPostings: 'नौकरी के पद',
    marketSort: "क्रमबद्ध करें",
    marketFilter: "फ़िल्टर करें",
    marketReset: 'रीसेट करें',
    marketFilterGalleries: 'गैलरी',
    marketFilterCategories: 'श्रेणियाँ',
    recent: "हाल ही का",
    earlier: "इससे पहले",
    minuteAgo: "{count} मिनट पहले",
    hourAgo: "{count} घंटे पहले",
    dayAgo: "{count} दिन पहले",
    weekAgo: "{count} सप्ताह पहले",
    on: 'पर',
    readArticle: "लेख पढ़ें",
    viewPosting: "पोस्टिंग देखें",
    moreNumber: "+{count} और",


    // empty content text
    noNewsArticlesFound: "कोई समाचार लेख नहीं मिला",
    nothingMatchSearch: "ऐसा लगता है कि हमें आपकी खोज से मेल खाने वाला कुछ भी नहीं मिला। अलग-अलग कीवर्ड आज़माएं या नवीनतम अपडेट के लिए बाद में फिर से देखें!",
    noJobListingsAvailable: "कोई नौकरी लिस्टिंग उपलब्ध नहीं",
    noJobPostingsMatching: "ऐसा लगता है कि आपकी खोज से मेल खाने वाली कोई नौकरी पोस्टिंग नहीं है। अलग-अलग कीवर्ड आज़माएं या नए अवसरों का पता लगाने के लिए बाद में वापस आएं।",
    noAdsFound: "कोई विज्ञापन नहीं मिला",
    noAdsFoundDesc: "फिलहाल कोई नया विज्ञापन नहीं मिला। नवीनतम अपडेट के लिए जल्द ही वापस आएं।",
    noActivitiesTrackedYet: 'अभी तक कोई गतिविधि ट्रैक नहीं की गई है',
    noAdsMatch: "खोज से कोई विज्ञापन मेल नहीं खाया",
    noAdsMatchDesc: "हम आपकी खोज से मेल खाने वाले विज्ञापन नहीं ढूंढ सके। अपने कीवर्ड बदलकर देखें या नए अपडेट के लिए जल्द ही दोबारा जाँचें।",
    noTrackedAnyActivities: "हमने अभी तक इस कंपनी के लिए कोई गतिविधि ट्रैक नहीं की है। अपडेट के लिए बाद में फिर से देखें",
    noTechnologiesFound: 'कोई तकनीक नहीं मिली',
    cantFindAnyInformationOnTheTechnologies: "हमें इस कंपनी द्वारा उपयोग की जाने वाली तकनीकों के बारे में कोई जानकारी नहीं मिल सकी। अपडेट के लिए बने रहें।",
  

    // company info
    seeLess: "कम देखें",
    seeMore: "और देखें",


    // technology
  
  };